var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 612 612",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M515.3 162.8l-7.5 2.4-40.2 3.6-11.3 18.1-8.2-2.6-32-28.8-4.6-15-6.2-16-20.1-18-23.7-4.6-.5 10.8 23.2 22.7 11.4 13.4-12.8 6.7-10.4-3.1-15.6-6.5.5-12.6-20.4-8.4-6.8 29.5-20.6 4.7 2 16.5 26.8 5.2 4.6-26.3 22.2 3.3 10.3 6h16.5l11.3 22.7 30 30.4-2.2 11.8-24.2-3.1-41.8 21.1-30 36-3.9 16h-10.8l-20.1-9.3-19.5 9.3 4.9 20.6 8.5-9.8 15-.5-1 18.5 12.4 3.6 12.4 13.9 20.2-5.7 23.1 3.6 26.8 7.2 13.4 1.6 22.7 25.8 43.8 25.8-28.3 54.1-29.9 13.9-11.7 30.9-43.3 28.9-4.6 16.7C475.7 521.1 558 421.8 558 303c0-51.9-15.7-100.2-42.7-140.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335 434.7l-18.4-34 16.8-35.1-16.8-5-18.9-19-41.9-9.4-13.9-29.2v17.3h-6.1l-36.1-49v-40.2l-26.5-43-42 7.5h-28.3l-14.2-9.3 18.2-14.4-18.3 4.1C66.8 213.3 54 256.6 54 303c0 139.2 112.8 252 252 252 10.7 0 21.2-.9 31.6-2.2l-2.6-30.5s11.6-45.3 11.6-46.9c0-1.5-11.6-40.7-11.6-40.7zM147.7 132.2l44.8-6.2 20.6-11.3 23.2 6.7 37.1-2.1 12.7-20 18.5 3 45-4.2L362 84.5l17.5-11.7 24.7 3.7 9-1.4C380.7 59.8 344.4 51 306 51c-78.2 0-148.2 35.7-194.3 91.6h.1l35.9-10.4zM316.6 76l25.7-14.2 16.5 9.5L335 89.6l-22.8 2.3-10.3-6.7 14.7-9.2zm-76.2 2.1l11.4 4.7 14.9-4.7 8.1 14-34.3 9-16.5-9.7c-.1.1 16-10.3 16.4-13.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default ForwardRef;